import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
// import AdbIcon from '@mui/icons-material/Adb';

import bike from "../bike.jpg";
// import mtbSmall from "../images/mtbSmall.jpg";
import { useNavigate } from "react-router-dom";

const pages = ["HOME", "OVERVIEW", "EXPLORE", "MAPS", "ABOUT"];

const ResponsiveAppBar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const navigate = useNavigate();

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
    // navigate(`/`)
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
    // navigate(`/about`)
  };

  return (
    <AppBar
      position="relative"
      sx={{
        backgroundColor: "rgb(0, 0, 0, 0.15)",
        zIndex: "6",
      }}
    >
      <Container
        maxWidth="xl"
        sx={
          {
            // height: "40px",
          }
        }
      >
        <Toolbar disableGutters>
          {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} /> */}

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page}
                  onClick={() => {
                    if (page === "HOME") {
                      navigate("/");
                    }
                    if (page === "OVERVIEW") {
                      navigate("/overview");
                    }
                    if (page === "EXPLORE") {
                      navigate("/explore");
                    }
                    if (page === "ABOUT") {
                      navigate("/about");
                    }
                    if (page === "MAPS") {
                      console.log("maps");
                      navigate("/maps");
                    }
                    handleCloseNavMenu();
                  }}
                >
                  <Typography textAlign="center">{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Box
            sx={{
              display: {
                xs: "none",
                md: "flex",
                justifyContent: "flex-end",
                mr: 1,
              },
            }}
          >
            <img id="logoPicture" src={bike} alt="Mountain bike logo" />
          </Box>

          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
              minWidth: "fit-content",
            }}
          >
            MTB CHRONICLES
          </Typography>

          {/* <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} /> */}

          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              width: 200,
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
              minWidth: "fit-content",
            }}
          >
            {/* <img id="logoMtbSmall" src={mtbSmall} alt="mtbSmall.jpg" /> */}
            MTB CHRONICLES
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={() => {
                  if (page === "HOME") {
                    navigate("/");
                  }
                  if (page === "OVERVIEW") {
                    navigate("/overview");
                  }
                  if (page === "EXPLORE") {
                    navigate("/explore");
                  }
                  if (page === "MAPS") {
                    console.log("maps");
                    navigate("/maps");
                  }
                  if (page === "ABOUT") {
                    navigate("/about");
                  }
                }}
                sx={{ my: 2, color: "white", display: "block" }}
              >
                {page}
              </Button>
            ))}
          </Box>

          {/* <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="User avatar" src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box> */}
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default ResponsiveAppBar;
